<template>
  <div class="mb-4">
    <img src="@/assets/empty-folder-illustration.svg" class="img-fluid" />
  </div>
</template>
<script>
export default {
  name: 'EmptyIllustration'
}
</script>